import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'screen';

export const { focus, update, prune, remove, patterns, send, resolve, reject } =
  createLifecycleFor(TYPE);
